/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Emailinvalid1Inputs */

const zh_auth_emailinvalid1 = /** @type {(inputs: Auth_Emailinvalid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请输入有效的邮箱地址`)
};

const en_auth_emailinvalid1 = /** @type {(inputs: Auth_Emailinvalid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please enter a valid email address`)
};

const es_auth_emailinvalid1 = /** @type {(inputs: Auth_Emailinvalid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingresa una dirección de correo válida`)
};

/**
* | output |
* | --- |
* | "Please enter a valid email address" |
*
* @param {Auth_Emailinvalid1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const auth_emailinvalid1 = /** @type {((inputs?: Auth_Emailinvalid1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Emailinvalid1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_auth_emailinvalid1(inputs)
	if (locale === "en") return en_auth_emailinvalid1(inputs)
	return es_auth_emailinvalid1(inputs)
});
export { auth_emailinvalid1 as "auth_emailInvalid" }